module.exports = __webpack_public_path__ + "static/radha-049105af847b6e8b1a03da8d32fc3cd5.jpg";